const affiliateTranslations = {
  en: {
    loading: "Loading affiliate dashboard…",
    copied: "Copied to clipboard",
    loginSubtitle: "Log in to generate your referral link and start earning premium access.",
    loginButton: "Log In to Join",
    rewardsBadge: "Premium Rewards",
    heroTitle: "Marstick Ambassador Program",
    heroSubtitle: "Invite real sailors, grow the community, and unlock premium access — no cash payouts, no spam, just high-quality referrals.",
    approved: "Approved",
    pending: "Pending",
    rejected: "Rejected",
    premiumDays: "Premium Days",
    toolkitTitle: "Your Referral Toolkit",
    referralCode: "Referral Code",
    referralLink: "Referral Link",
    copyReferralCode: "Copy referral code",
    copyReferralLink: "Copy referral link",
    referralNote: "To unlock premium content, your invitee must sign up through this referral link and become an approved quality referral. Approved referrals count toward your premium milestones.",
    qrAlt: "Referral QR code",
    shareText: "Join me on Marstick and unlock smarter sailing tools.",
    emailSubject: "Join Marstick",
    nextUnlock: "Next Unlock",
    newAmbassador: "New Ambassador",
    moreApproved: "more approved referrals to unlock",
    lifetimePremium: "Lifetime Premium",
    daysPremium: "days Premium",
    approvedProgress: "approved referrals",
    allMilestones: "You’ve reached every active milestone.",
    milestones: "Milestones",
    referrals: "referrals",
    referralReport: "Referral Report",
    approvedReferrals: "Approved referrals",
    rejectedReferrals: "Rejected referrals",
    noReferrals: "No referrals yet. Share your link to start your first milestone.",
    userId: "User ID",
    timestamp: "Timestamp",
    status: "Status",
    notAssigned: "Not assigned yet",
    notifications: "Notifications",
    noNotifications: "No affiliate notifications yet.",
    statusLabels: { approved: "approved", pending: "pending", rejected: "rejected", fraudulent: "fraudulent" }
  },
  he: {
    loading: "טוען את לוח השותפים…",
    copied: "הועתק ללוח",
    loginSubtitle: "התחברו כדי ליצור קישור הפניה ולהתחיל לצבור גישת פרימיום.",
    loginButton: "התחברות והצטרפות",
    rewardsBadge: "תגמולי פרימיום",
    heroTitle: "תוכנית השגרירים של Marstick",
    heroSubtitle: "הזמינו שייטים אמיתיים, הגדילו את הקהילה ופתחו גישת פרימיום — בלי תשלומים במזומן, בלי ספאם, רק הפניות איכותיות.",
    approved: "מאושרות",
    pending: "בהמתנה",
    rejected: "נדחו",
    premiumDays: "ימי פרימיום",
    toolkitTitle: "ערכת ההפניות שלך",
    referralCode: "קוד הפניה",
    referralLink: "קישור הפניה",
    copyReferralCode: "העתקת קוד הפניה",
    copyReferralLink: "העתקת קישור הפניה",
    referralNote: "כדי לפתוח תוכן פרימיום, המוזמן חייב להירשם דרך קישור ההפניה הזה ולהפוך להפניה איכותית מאושרת. הפניות מאושרות נספרות לאבני הדרך שלך.",
    qrAlt: "קוד QR להפניה",
    shareText: "הצטרפו אליי ל-Marstick ופתחו כלי שייט חכמים יותר.",
    emailSubject: "הצטרפו ל-Marstick",
    nextUnlock: "הפתיחה הבאה",
    newAmbassador: "שגריר חדש",
    moreApproved: "הפניות מאושרות נוספות לפתיחת",
    lifetimePremium: "פרימיום לכל החיים",
    daysPremium: "ימי פרימיום",
    approvedProgress: "הפניות מאושרות",
    allMilestones: "הגעת לכל אבני הדרך הפעילות.",
    milestones: "אבני דרך",
    referrals: "הפניות",
    referralReport: "דוח הפניות",
    approvedReferrals: "הפניות מאושרות",
    rejectedReferrals: "הפניות שנדחו",
    noReferrals: "עדיין אין הפניות. שתפו את הקישור כדי להתחיל את אבן הדרך הראשונה.",
    userId: "מזהה משתמש",
    timestamp: "זמן",
    status: "סטטוס",
    notAssigned: "עדיין לא הוקצה",
    notifications: "התראות",
    noNotifications: "עדיין אין התראות שותפים.",
    statusLabels: { approved: "מאושר", pending: "בהמתנה", rejected: "נדחה", fraudulent: "הונאה" }
  },
  es: {
    loading: "Cargando panel de afiliados…",
    copied: "Copiado al portapapeles",
    loginSubtitle: "Inicia sesión para generar tu enlace de referido y empezar a ganar acceso premium.",
    loginButton: "Iniciar sesión y unirse",
    rewardsBadge: "Recompensas Premium",
    heroTitle: "Programa de Embajadores Marstick",
    heroSubtitle: "Invita a navegantes reales, haz crecer la comunidad y desbloquea acceso premium: sin pagos en efectivo, sin spam, solo referidos de calidad.",
    approved: "Aprobados",
    pending: "Pendientes",
    rejected: "Rechazados",
    premiumDays: "Días Premium",
    toolkitTitle: "Tu kit de referidos",
    referralCode: "Código de referido",
    referralLink: "Enlace de referido",
    copyReferralCode: "Copiar código de referido",
    copyReferralLink: "Copiar enlace de referido",
    referralNote: "Para desbloquear contenido premium, tu invitado debe registrarse con este enlace y convertirse en un referido aprobado de calidad. Los referidos aprobados cuentan para tus hitos premium.",
    qrAlt: "Código QR de referido",
    shareText: "Únete conmigo a Marstick y desbloquea herramientas de navegación más inteligentes.",
    emailSubject: "Únete a Marstick",
    nextUnlock: "Próximo desbloqueo",
    newAmbassador: "Nuevo embajador",
    moreApproved: "referidos aprobados más para desbloquear",
    lifetimePremium: "Premium de por vida",
    daysPremium: "días Premium",
    approvedProgress: "referidos aprobados",
    allMilestones: "Has alcanzado todos los hitos activos.",
    milestones: "Hitos",
    referrals: "referidos",
    referralReport: "Informe de referidos",
    approvedReferrals: "Referidos aprobados",
    rejectedReferrals: "Referidos rechazados",
    noReferrals: "Aún no hay referidos. Comparte tu enlace para empezar tu primer hito.",
    userId: "ID de usuario",
    timestamp: "Fecha y hora",
    status: "Estado",
    notAssigned: "Aún no asignado",
    notifications: "Notificaciones",
    noNotifications: "Aún no hay notificaciones de afiliado.",
    statusLabels: { approved: "aprobado", pending: "pendiente", rejected: "rechazado", fraudulent: "fraudulento" }
  },
  it: {
    loading: "Caricamento dashboard affiliati…",
    copied: "Copiato negli appunti",
    loginSubtitle: "Accedi per generare il tuo link referral e iniziare a ottenere accesso premium.",
    loginButton: "Accedi e unisciti",
    rewardsBadge: "Ricompense Premium",
    heroTitle: "Programma Ambassador Marstick",
    heroSubtitle: "Invita veri velisti, fai crescere la community e sblocca l’accesso premium: niente pagamenti in contanti, niente spam, solo referral di qualità.",
    approved: "Approvati",
    pending: "In attesa",
    rejected: "Rifiutati",
    premiumDays: "Giorni Premium",
    toolkitTitle: "Il tuo toolkit referral",
    referralCode: "Codice referral",
    referralLink: "Link referral",
    copyReferralCode: "Copia codice referral",
    copyReferralLink: "Copia link referral",
    referralNote: "Per sbloccare contenuti premium, il tuo invitato deve registrarsi tramite questo link e diventare un referral di qualità approvato. I referral approvati contano per i tuoi traguardi premium.",
    qrAlt: "Codice QR referral",
    shareText: "Unisciti a me su Marstick e sblocca strumenti di navigazione più intelligenti.",
    emailSubject: "Unisciti a Marstick",
    nextUnlock: "Prossimo sblocco",
    newAmbassador: "Nuovo ambassador",
    moreApproved: "altri referral approvati per sbloccare",
    lifetimePremium: "Premium a vita",
    daysPremium: "giorni Premium",
    approvedProgress: "referral approvati",
    allMilestones: "Hai raggiunto tutti i traguardi attivi.",
    milestones: "Traguardi",
    referrals: "referral",
    referralReport: "Report referral",
    approvedReferrals: "Referral approvati",
    rejectedReferrals: "Referral rifiutati",
    noReferrals: "Ancora nessun referral. Condividi il link per iniziare il primo traguardo.",
    userId: "ID utente",
    timestamp: "Data e ora",
    status: "Stato",
    notAssigned: "Non ancora assegnato",
    notifications: "Notifiche",
    noNotifications: "Ancora nessuna notifica affiliato.",
    statusLabels: { approved: "approvato", pending: "in attesa", rejected: "rifiutato", fraudulent: "fraudolento" }
  },
  fr: {
    loading: "Chargement du tableau affilié…",
    copied: "Copié dans le presse-papiers",
    loginSubtitle: "Connectez-vous pour générer votre lien de parrainage et commencer à gagner un accès premium.",
    loginButton: "Se connecter et rejoindre",
    rewardsBadge: "Récompenses Premium",
    heroTitle: "Programme Ambassadeur Marstick",
    heroSubtitle: "Invitez de vrais navigateurs, développez la communauté et débloquez l’accès premium — pas de paiement en espèces, pas de spam, seulement des parrainages de qualité.",
    approved: "Approuvés",
    pending: "En attente",
    rejected: "Rejetés",
    premiumDays: "Jours Premium",
    toolkitTitle: "Votre kit de parrainage",
    referralCode: "Code de parrainage",
    referralLink: "Lien de parrainage",
    copyReferralCode: "Copier le code de parrainage",
    copyReferralLink: "Copier le lien de parrainage",
    referralNote: "Pour débloquer du contenu premium, votre invité doit s’inscrire via ce lien et devenir un parrainage approuvé de qualité. Les parrainages approuvés comptent pour vos étapes premium.",
    qrAlt: "QR code de parrainage",
    shareText: "Rejoignez-moi sur Marstick et débloquez des outils de navigation plus intelligents.",
    emailSubject: "Rejoignez Marstick",
    nextUnlock: "Prochain déblocage",
    newAmbassador: "Nouvel ambassadeur",
    moreApproved: "parrainages approuvés de plus pour débloquer",
    lifetimePremium: "Premium à vie",
    daysPremium: "jours Premium",
    approvedProgress: "parrainages approuvés",
    allMilestones: "Vous avez atteint toutes les étapes actives.",
    milestones: "Étapes",
    referrals: "parrainages",
    referralReport: "Rapport de parrainage",
    approvedReferrals: "Parrainages approuvés",
    rejectedReferrals: "Parrainages rejetés",
    noReferrals: "Aucun parrainage pour le moment. Partagez votre lien pour commencer votre première étape.",
    userId: "ID utilisateur",
    timestamp: "Horodatage",
    status: "Statut",
    notAssigned: "Pas encore attribué",
    notifications: "Notifications",
    noNotifications: "Aucune notification affiliée pour le moment.",
    statusLabels: { approved: "approuvé", pending: "en attente", rejected: "rejeté", fraudulent: "frauduleux" }
  },
  de: {
    loading: "Affiliate-Dashboard wird geladen…",
    copied: "In die Zwischenablage kopiert",
    loginSubtitle: "Melde dich an, um deinen Empfehlungslink zu erstellen und Premium-Zugang zu verdienen.",
    loginButton: "Einloggen und beitreten",
    rewardsBadge: "Premium-Prämien",
    heroTitle: "Marstick Ambassador-Programm",
    heroSubtitle: "Lade echte Segler ein, vergrößere die Community und schalte Premium-Zugang frei — keine Barauszahlungen, kein Spam, nur hochwertige Empfehlungen.",
    approved: "Genehmigt",
    pending: "Ausstehend",
    rejected: "Abgelehnt",
    premiumDays: "Premium-Tage",
    toolkitTitle: "Dein Empfehlungs-Toolkit",
    referralCode: "Empfehlungscode",
    referralLink: "Empfehlungslink",
    copyReferralCode: "Empfehlungscode kopieren",
    copyReferralLink: "Empfehlungslink kopieren",
    referralNote: "Um Premium-Inhalte freizuschalten, muss sich deine eingeladene Person über diesen Link registrieren und als hochwertige Empfehlung genehmigt werden. Genehmigte Empfehlungen zählen zu deinen Premium-Meilensteinen.",
    qrAlt: "Empfehlungs-QR-Code",
    shareText: "Komm mit mir zu Marstick und schalte intelligentere Segeltools frei.",
    emailSubject: "Marstick beitreten",
    nextUnlock: "Nächste Freischaltung",
    newAmbassador: "Neuer Ambassador",
    moreApproved: "weitere genehmigte Empfehlungen zum Freischalten von",
    lifetimePremium: "Premium auf Lebenszeit",
    daysPremium: "Premium-Tage",
    approvedProgress: "genehmigte Empfehlungen",
    allMilestones: "Du hast alle aktiven Meilensteine erreicht.",
    milestones: "Meilensteine",
    referrals: "Empfehlungen",
    referralReport: "Empfehlungsbericht",
    approvedReferrals: "Genehmigte Empfehlungen",
    rejectedReferrals: "Abgelehnte Empfehlungen",
    noReferrals: "Noch keine Empfehlungen. Teile deinen Link, um den ersten Meilenstein zu starten.",
    userId: "Benutzer-ID",
    timestamp: "Zeitstempel",
    status: "Status",
    notAssigned: "Noch nicht zugewiesen",
    notifications: "Benachrichtigungen",
    noNotifications: "Noch keine Affiliate-Benachrichtigungen.",
    statusLabels: { approved: "genehmigt", pending: "ausstehend", rejected: "abgelehnt", fraudulent: "betrügerisch" }
  },
  pt: {
    loading: "Carregando painel de afiliados…",
    copied: "Copiado para a área de transferência",
    loginSubtitle: "Entre para gerar seu link de indicação e começar a ganhar acesso premium.",
    loginButton: "Entrar e participar",
    rewardsBadge: "Recompensas Premium",
    heroTitle: "Programa de Embaixadores Marstick",
    heroSubtitle: "Convide velejadores reais, aumente a comunidade e desbloqueie acesso premium — sem pagamentos em dinheiro, sem spam, apenas indicações de qualidade.",
    approved: "Aprovadas",
    pending: "Pendentes",
    rejected: "Rejeitadas",
    premiumDays: "Dias Premium",
    toolkitTitle: "Seu kit de indicação",
    referralCode: "Código de indicação",
    referralLink: "Link de indicação",
    copyReferralCode: "Copiar código de indicação",
    copyReferralLink: "Copiar link de indicação",
    referralNote: "Para desbloquear conteúdo premium, seu convidado deve se cadastrar por este link e se tornar uma indicação de qualidade aprovada. Indicações aprovadas contam para seus marcos premium.",
    qrAlt: "Código QR de indicação",
    shareText: "Junte-se a mim no Marstick e desbloqueie ferramentas náuticas mais inteligentes.",
    emailSubject: "Junte-se ao Marstick",
    nextUnlock: "Próximo desbloqueio",
    newAmbassador: "Novo embaixador",
    moreApproved: "indicações aprovadas a mais para desbloquear",
    lifetimePremium: "Premium vitalício",
    daysPremium: "dias Premium",
    approvedProgress: "indicações aprovadas",
    allMilestones: "Você alcançou todos os marcos ativos.",
    milestones: "Marcos",
    referrals: "indicações",
    referralReport: "Relatório de indicações",
    approvedReferrals: "Indicações aprovadas",
    rejectedReferrals: "Indicações rejeitadas",
    noReferrals: "Ainda não há indicações. Compartilhe seu link para iniciar o primeiro marco.",
    userId: "ID do usuário",
    timestamp: "Data e hora",
    status: "Status",
    notAssigned: "Ainda não atribuído",
    notifications: "Notificações",
    noNotifications: "Ainda não há notificações de afiliado.",
    statusLabels: { approved: "aprovada", pending: "pendente", rejected: "rejeitada", fraudulent: "fraudulenta" }
  },
  ar: {
    loading: "جارٍ تحميل لوحة الشركاء…",
    copied: "تم النسخ إلى الحافظة",
    loginSubtitle: "سجّل الدخول لإنشاء رابط الإحالة والبدء في كسب وصول بريميوم.",
    loginButton: "تسجيل الدخول والانضمام",
    rewardsBadge: "مكافآت بريميوم",
    heroTitle: "برنامج سفراء Marstick",
    heroSubtitle: "ادعُ بحّارة حقيقيين، وساهم في نمو المجتمع، وافتح وصول بريميوم — بلا دفعات نقدية، بلا رسائل مزعجة، فقط إحالات عالية الجودة.",
    approved: "معتمدة",
    pending: "قيد الانتظار",
    rejected: "مرفوضة",
    premiumDays: "أيام بريميوم",
    toolkitTitle: "مجموعة أدوات الإحالة الخاصة بك",
    referralCode: "رمز الإحالة",
    referralLink: "رابط الإحالة",
    copyReferralCode: "نسخ رمز الإحالة",
    copyReferralLink: "نسخ رابط الإحالة",
    referralNote: "لفتح محتوى بريميوم، يجب أن يسجل المدعو من خلال هذا الرابط وأن يصبح إحالة جودة معتمدة. الإحالات المعتمدة تُحتسب ضمن إنجازاتك.",
    qrAlt: "رمز QR للإحالة",
    shareText: "انضم إليّ على Marstick وافتح أدوات إبحار أكثر ذكاءً.",
    emailSubject: "انضم إلى Marstick",
    nextUnlock: "الفتح التالي",
    newAmbassador: "سفير جديد",
    moreApproved: "إحالات معتمدة إضافية لفتح",
    lifetimePremium: "بريميوم مدى الحياة",
    daysPremium: "أيام بريميوم",
    approvedProgress: "إحالات معتمدة",
    allMilestones: "لقد وصلت إلى كل الإنجازات النشطة.",
    milestones: "الإنجازات",
    referrals: "إحالات",
    referralReport: "تقرير الإحالات",
    approvedReferrals: "الإحالات المعتمدة",
    rejectedReferrals: "الإحالات المرفوضة",
    noReferrals: "لا توجد إحالات بعد. شارك رابطك لبدء أول إنجاز.",
    userId: "معرّف المستخدم",
    timestamp: "الوقت",
    status: "الحالة",
    notAssigned: "لم يتم التعيين بعد",
    notifications: "الإشعارات",
    noNotifications: "لا توجد إشعارات شركاء بعد.",
    statusLabels: { approved: "معتمد", pending: "قيد الانتظار", rejected: "مرفوض", fraudulent: "احتيالي" }
  },
  el: {
    loading: "Φόρτωση πίνακα συνεργατών…",
    copied: "Αντιγράφηκε στο πρόχειρο",
    loginSubtitle: "Συνδεθείτε για να δημιουργήσετε τον σύνδεσμο σύστασης και να αρχίσετε να κερδίζετε premium πρόσβαση.",
    loginButton: "Σύνδεση και συμμετοχή",
    rewardsBadge: "Premium ανταμοιβές",
    heroTitle: "Πρόγραμμα Πρεσβευτών Marstick",
    heroSubtitle: "Προσκαλέστε πραγματικούς ιστιοπλόους, μεγαλώστε την κοινότητα και ξεκλειδώστε premium πρόσβαση — χωρίς πληρωμές μετρητών, χωρίς spam, μόνο ποιοτικές συστάσεις.",
    approved: "Εγκρίθηκαν",
    pending: "Σε αναμονή",
    rejected: "Απορρίφθηκαν",
    premiumDays: "Premium ημέρες",
    toolkitTitle: "Το κιτ συστάσεών σας",
    referralCode: "Κωδικός σύστασης",
    referralLink: "Σύνδεσμος σύστασης",
    copyReferralCode: "Αντιγραφή κωδικού σύστασης",
    copyReferralLink: "Αντιγραφή συνδέσμου σύστασης",
    referralNote: "Για να ξεκλειδώσετε premium περιεχόμενο, ο προσκεκλημένος σας πρέπει να εγγραφεί μέσω αυτού του συνδέσμου και να εγκριθεί ως ποιοτική σύσταση. Οι εγκεκριμένες συστάσεις μετρούν στους premium στόχους σας.",
    qrAlt: "QR κωδικός σύστασης",
    shareText: "Ελάτε μαζί μου στο Marstick και ξεκλειδώστε πιο έξυπνα εργαλεία ιστιοπλοΐας.",
    emailSubject: "Εγγραφείτε στο Marstick",
    nextUnlock: "Επόμενο ξεκλείδωμα",
    newAmbassador: "Νέος πρεσβευτής",
    moreApproved: "επιπλέον εγκεκριμένες συστάσεις για ξεκλείδωμα",
    lifetimePremium: "Premium εφ’ όρου ζωής",
    daysPremium: "ημέρες Premium",
    approvedProgress: "εγκεκριμένες συστάσεις",
    allMilestones: "Έχετε φτάσει κάθε ενεργό στόχο.",
    milestones: "Ορόσημα",
    referrals: "συστάσεις",
    referralReport: "Αναφορά συστάσεων",
    approvedReferrals: "Εγκεκριμένες συστάσεις",
    rejectedReferrals: "Απορριφθείσες συστάσεις",
    noReferrals: "Δεν υπάρχουν ακόμη συστάσεις. Μοιραστείτε τον σύνδεσμό σας για να ξεκινήσετε το πρώτο ορόσημο.",
    userId: "ID χρήστη",
    timestamp: "Χρόνος",
    status: "Κατάσταση",
    notAssigned: "Δεν έχει ανατεθεί ακόμη",
    notifications: "Ειδοποιήσεις",
    noNotifications: "Δεν υπάρχουν ακόμη ειδοποιήσεις συνεργατών.",
    statusLabels: { approved: "εγκρίθηκε", pending: "σε αναμονή", rejected: "απορρίφθηκε", fraudulent: "δόλιο" }
  },
  ru: {
    loading: "Загрузка панели партнера…",
    copied: "Скопировано в буфер обмена",
    loginSubtitle: "Войдите, чтобы создать реферальную ссылку и начать получать premium-доступ.",
    loginButton: "Войти и присоединиться",
    rewardsBadge: "Premium-награды",
    heroTitle: "Программа амбассадоров Marstick",
    heroSubtitle: "Приглашайте настоящих яхтсменов, развивайте сообщество и открывайте premium-доступ — без денежных выплат, без спама, только качественные рекомендации.",
    approved: "Одобрено",
    pending: "Ожидают",
    rejected: "Отклонено",
    premiumDays: "Premium-дни",
    toolkitTitle: "Ваш набор для рекомендаций",
    referralCode: "Реферальный код",
    referralLink: "Реферальная ссылка",
    copyReferralCode: "Скопировать реферальный код",
    copyReferralLink: "Скопировать реферальную ссылку",
    referralNote: "Чтобы открыть premium-контент, приглашенный пользователь должен зарегистрироваться по этой ссылке и стать одобренной качественной рекомендацией. Одобренные рекомендации засчитываются в ваши premium-этапы.",
    qrAlt: "QR-код рекомендации",
    shareText: "Присоединяйтесь ко мне в Marstick и откройте более умные инструменты для яхтинга.",
    emailSubject: "Присоединяйтесь к Marstick",
    nextUnlock: "Следующая награда",
    newAmbassador: "Новый амбассадор",
    moreApproved: "дополнительных одобренных рекомендаций, чтобы открыть",
    lifetimePremium: "Premium навсегда",
    daysPremium: "дней Premium",
    approvedProgress: "одобренных рекомендаций",
    allMilestones: "Вы достигли всех активных этапов.",
    milestones: "Этапы",
    referrals: "рекомендаций",
    referralReport: "Отчет по рекомендациям",
    approvedReferrals: "Одобренные рекомендации",
    rejectedReferrals: "Отклоненные рекомендации",
    noReferrals: "Рекомендаций пока нет. Поделитесь ссылкой, чтобы начать первый этап.",
    userId: "ID пользователя",
    timestamp: "Время",
    status: "Статус",
    notAssigned: "Еще не назначено",
    notifications: "Уведомления",
    noNotifications: "Партнерских уведомлений пока нет.",
    statusLabels: { approved: "одобрено", pending: "ожидает", rejected: "отклонено", fraudulent: "мошенничество" }
  },
  tr: {
    loading: "Ortaklık paneli yükleniyor…",
    copied: "Panoya kopyalandı",
    loginSubtitle: "Referans bağlantını oluşturmak ve premium erişim kazanmaya başlamak için giriş yap.",
    loginButton: "Giriş yap ve katıl",
    rewardsBadge: "Premium Ödüller",
    heroTitle: "Marstick Elçi Programı",
    heroSubtitle: "Gerçek denizcileri davet et, topluluğu büyüt ve premium erişim kazan — nakit ödeme yok, spam yok, sadece kaliteli referanslar.",
    approved: "Onaylanan",
    pending: "Bekleyen",
    rejected: "Reddedilen",
    premiumDays: "Premium Günleri",
    toolkitTitle: "Referans araç kitin",
    referralCode: "Referans kodu",
    referralLink: "Referans bağlantısı",
    copyReferralCode: "Referans kodunu kopyala",
    copyReferralLink: "Referans bağlantısını kopyala",
    referralNote: "Premium içeriği açmak için davet ettiğin kişi bu bağlantıdan kaydolmalı ve onaylı kaliteli referans olmalıdır. Onaylı referanslar premium kilometre taşlarına sayılır.",
    qrAlt: "Referans QR kodu",
    shareText: "Marstick’te bana katıl ve daha akıllı denizcilik araçlarını aç.",
    emailSubject: "Marstick’e katıl",
    nextUnlock: "Sonraki kilit açma",
    newAmbassador: "Yeni elçi",
    moreApproved: "onaylı referans daha gerekli:",
    lifetimePremium: "Ömür boyu Premium",
    daysPremium: "gün Premium",
    approvedProgress: "onaylı referans",
    allMilestones: "Tüm aktif kilometre taşlarına ulaştın.",
    milestones: "Kilometre taşları",
    referrals: "referans",
    referralReport: "Referans raporu",
    approvedReferrals: "Onaylı referanslar",
    rejectedReferrals: "Reddedilen referanslar",
    noReferrals: "Henüz referans yok. İlk kilometre taşını başlatmak için bağlantını paylaş.",
    userId: "Kullanıcı ID",
    timestamp: "Zaman",
    status: "Durum",
    notAssigned: "Henüz atanmadı",
    notifications: "Bildirimler",
    noNotifications: "Henüz ortaklık bildirimi yok.",
    statusLabels: { approved: "onaylandı", pending: "beklemede", rejected: "reddedildi", fraudulent: "hileli" }
  },
  zh: {
    loading: "正在加载推广仪表板…",
    copied: "已复制到剪贴板",
    loginSubtitle: "登录后生成你的推荐链接，并开始获得高级访问权限。",
    loginButton: "登录并加入",
    rewardsBadge: "高级奖励",
    heroTitle: "Marstick 大使计划",
    heroSubtitle: "邀请真正的水手加入 Marstick，壮大全球航海社区并解锁高级访问权限——没有现金返利、没有垃圾推广，只有高质量推荐、透明的奖励里程碑和适合水手长期使用的高级航海工具。",
    approved: "已批准",
    pending: "待处理",
    rejected: "已拒绝",
    premiumDays: "高级天数",
    toolkitTitle: "你的推荐工具包",
    referralCode: "推荐代码",
    referralLink: "推荐链接",
    copyReferralCode: "复制推荐代码",
    copyReferralLink: "复制推荐链接",
    referralNote: "要解锁高级内容，被邀请人必须通过此推荐链接注册并成为已批准的高质量推荐。已批准推荐会计入你的高级里程碑。",
    qrAlt: "推荐二维码",
    shareText: "和我一起加入 Marstick，解锁更智能的航海工具。",
    emailSubject: "加入 Marstick",
    nextUnlock: "下一个解锁",
    newAmbassador: "新大使",
    moreApproved: "个更多已批准推荐即可解锁",
    lifetimePremium: "终身 Premium",
    daysPremium: "天 Premium",
    approvedProgress: "已批准推荐",
    allMilestones: "你已达到所有有效里程碑。",
    milestones: "里程碑",
    referrals: "推荐",
    referralReport: "推荐报告",
    approvedReferrals: "已批准推荐",
    rejectedReferrals: "已拒绝推荐",
    noReferrals: "还没有推荐。分享你的链接以开始第一个里程碑。",
    userId: "用户 ID",
    timestamp: "时间",
    status: "状态",
    notAssigned: "尚未分配",
    notifications: "通知",
    noNotifications: "还没有推广通知。",
    statusLabels: { approved: "已批准", pending: "待处理", rejected: "已拒绝", fraudulent: "欺诈" }
  }
};

export function getAffiliateTranslations(language = "en") {
  const base = affiliateTranslations.en;
  const selected = affiliateTranslations[language] || base;
  return {
    ...base,
    ...selected,
    statusLabels: { ...base.statusLabels, ...(selected.statusLabels || {}) },
  };
}